import { property, pick, compose } from 'underscore';
import { routing as routingSelectors } from 'redux-selectors';

const seoState = property('seo');

export const getMetaData = (state) => pick(seoState(state), 'title', 'description', 'fetching', 'isDefault', 'prerenderReady');
export const getContentAutorules = (state) => pick(seoState(state), 'description', 'fetching', 'prerenderReady');
export const getHeading = compose(property('heading'), seoState);
export const getRobotsContent = (state) => pick(seoState(state), 'nofollow', 'noindex', 'unavailableAfter');
export const getCopySections = compose(property('copySections'), seoState);
export const getCustomPath = compose(property('customPath'), seoState);
const getMetaInfo = compose(property('metaInfo'), seoState);

const { getCurrentPath } = routingSelectors;

export const getCurrentMetaInfo = (state) => {
  const metaInfo = getMetaInfo(state);

  if (metaInfo && getCurrentPath(state) === metaInfo.path) {
    return metaInfo;
  }

  return null;
};

export const getCurrentContentAutorulesTemplate = (state) => getMetaInfo(state);
